// Full-screen status page for 404 / 403 (CEO-approved mockup 28/09/2026,
// spot 6): the code in gold foil over the tall GAO NAU lettering sunk into
// deep brown, one sentence, one way back.
import { Link } from "@tanstack/react-router";
import { BRAND_ART, BrandMark } from "./BrandArt";

export function BrandStatusPage({
  code,
  title,
  description,
}: {
  code: string;
  title: string;
  description: string;
}) {
  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#4A370B] px-6 text-center text-[#FFFEF5]">
      <BrandMark
        src={BRAND_ART.tallLettering}
        className="absolute -bottom-24 -right-24 h-[560px] w-[600px] text-[#FFFEF5]/10 md:-right-10 md:h-[820px] md:w-[880px]"
      />
      <p
        className="gn-foil-text relative m-0 text-[112px] leading-[0.9] md:text-[168px]"
        style={{ fontFamily: "var(--font-numeral)" }}
      >
        {code}
      </p>
      <h1
        className="relative m-0 mt-4 text-[26px] font-normal leading-tight md:text-[34px]"
        style={{ fontFamily: "var(--font-art)" }}
      >
        {title}
      </h1>
      <p className="relative m-0 mt-3 max-w-[360px] text-[15px] leading-relaxed">{description}</p>
      <Link
        to="/dashboard"
        className="relative mt-7 inline-flex min-h-11 items-center rounded-full bg-[#FFFEF5] px-6 text-sm font-semibold text-[#4A370B] transition-opacity hover:opacity-90"
      >
        Về trang chính
      </Link>
    </main>
  );
}
